import React from 'react';
// import React, { useRef, useState, useEffect } from 'react';
import './Filters.css';

const Filters = ({
  selectedCategory,
  onCategorySelect
}) => {
  
  const categories = ['All', 'Meat', 'Seafood', 'Vegetables', 'Fruits', 'Grains', 'Dairy', 'Pantry'];
  const categoryLabels = {
    All: 'All',
    Meat: 'Meat',
    Seafood: 'Seafood',
    Vegetables: 'Vegetables',
    Fruits: 'Fruits',
    Grains: 'Grains',
    Dairy: 'Dairy',
    Pantry: 'Pantry'
  };

  const isAllActive = !selectedCategory;

  
  return (
    <div className="filters-container">
      <div className="filters-section">
        <label className="filters-label">Category</label>
        <div className="category-filters">
          {categories.map((category) => {
            const isActive = category === 'All'
              ? isAllActive
              : selectedCategory === category;
            
            return (
              <button
                key={category}
                className={`category-filter-btn ${isActive ? 'active' : ''}`}
                onClick={() => onCategorySelect(category)}
              >
                {categoryLabels[category]}
              </button>
            );
          })}
        </div>
      </div>      
    </div>
  );
};

export default Filters;

